"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectClientFilteredProbsMap = exports.selectHotProbsMarkets = exports.selectHotProbabilitiesGroupsSports = exports.selectHotProbabilitiesGroups = exports.selectOutcomeCategoryById = exports.getOutcomeCategories = exports.selectCurrencyMaxPayout = exports.selectCurrencyMinBet = exports.selectAccountCurrencyData = exports.selectSportsList = exports.selectSports = exports.selectMarketGroupById = exports.selectMarketGroups = exports.selectMarketCategoryById = exports.selectMarketCategories = exports.selectOutcomeTypeById = exports.selectTopTagId = exports.selectEntityTags = exports.selectOutcomeTypes = exports.selectMainOutcomeTypes = exports.selectCommonDataFetchItems = exports.selectMatchPhase = exports.selectMatchPhases = exports.selectIsGenericSport = exports.selectChildrenSportMap = exports.selectChildrenSportIds = exports.selectSport = exports.getSystemCurrencies = exports.getSystemCurrencyById = exports.getCurrencyById = exports.getCurrencies = exports.getMarketById = exports.selectVMarketsByMarketId = exports.selectVMarketIdsByMarket = exports.selectMarkets = exports.getOutcomeTypeById = exports.selectVirtualMarketInfo = exports.selectVirtualMarketsByIds = exports.selectVirtualMarketsInfo = exports.selectVirtualCategoryInfo = exports.selectVirtualCategoriesSortedIds = exports.selectVirtualCategoriesInfo = exports.selectVirtualMarketInfosMap = exports.selectVirtualCategories = exports.selectCategoryMarketInfosMap = exports.selectMarketGroupsMap = exports.selectMarketCategoriesMap = exports.getSportsIdsOrder = exports.getCommonDataEntries = exports.getCommonDataProviderState = void 0;
exports.selectIsAllCommonDataLoaded = exports.selectLoadedOrNotCommonData = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const keyBy_1 = __importDefault(require("../../utils/functions/keyBy"));
const mapValues_1 = __importDefault(require("../../utils/functions/mapValues"));
const constants_1 = require("./constants");
const slices_1 = require("../../utils/@reduxjs/slices");
const selectors_1 = require("../AccountProvider/selectors");
const format_1 = require("../../utils/format");
const array_1 = require("../../utils/array");
const selectors_2 = require("../ConfigProvider/selectors");
const index_1 = require("../../utils/index");
const findHotProbsMarkets_1 = require("../../utils/markets/findHotProbsMarkets");
const findHotProbsMarketsOutcomesIds_1 = require("../../utils/markets/findHotProbsMarketsOutcomesIds");
const slice_1 = require("./slice");
const getCommonDataProviderState = (state) => state.commonDataProvider || slice_1.initialState;
exports.getCommonDataProviderState = getCommonDataProviderState;
const getCommonDataEntries = (state) => (0, exports.getCommonDataProviderState)(state).entries;
exports.getCommonDataEntries = getCommonDataEntries;
const getSportsIdsOrder = (state) => (0, exports.getCommonDataEntries)(state).sportsIdsOrder;
exports.getSportsIdsOrder = getSportsIdsOrder;
const selectMarketCategoriesMap = (state) => (0, exports.getCommonDataEntries)(state).marketCategories;
exports.selectMarketCategoriesMap = selectMarketCategoriesMap;
const selectMarketGroupsMap = (state) => (0, exports.getCommonDataEntries)(state).marketGroups;
exports.selectMarketGroupsMap = selectMarketGroupsMap;
const selectCategoryMarketInfosMap = (state) => (0, exports.getCommonDataEntries)(state).categoryMarketInfosMap;
exports.selectCategoryMarketInfosMap = selectCategoryMarketInfosMap;
const selectVirtualCategories = (state) => (0, exports.getCommonDataEntries)(state).virtualCategories;
exports.selectVirtualCategories = selectVirtualCategories;
const selectVirtualMarketInfosMap = (state) => (0, exports.getCommonDataEntries)(state).virtualMarketInfosMap;
exports.selectVirtualMarketInfosMap = selectVirtualMarketInfosMap;
const selectVirtualCategoriesInfo = (state) => {
    return (0, exports.getCommonDataEntries)(state).vCategoriesInfo.entries;
};
exports.selectVirtualCategoriesInfo = selectVirtualCategoriesInfo;
const selectVirtualCategoriesSortedIds = (state) => {
    return (0, exports.getCommonDataEntries)(state).vCategoriesInfo.sortedIds;
};
exports.selectVirtualCategoriesSortedIds = selectVirtualCategoriesSortedIds;
const selectVirtualCategoryInfo = (state, vCategoryId) => {
    return (0, exports.selectVirtualCategoriesInfo)(state)[vCategoryId];
};
exports.selectVirtualCategoryInfo = selectVirtualCategoryInfo;
const selectVirtualMarketsInfo = (state) => {
    return (0, exports.getCommonDataEntries)(state).vMarketsInfo;
};
exports.selectVirtualMarketsInfo = selectVirtualMarketsInfo;
exports.selectVirtualMarketsByIds = (0, toolkit_1.createSelector)([exports.selectVirtualMarketsInfo, (_, ids) => ids], (markets, ids) => {
    return ids.map((id) => markets[id]);
});
const selectVirtualMarketInfo = (state, vMarketId) => {
    return (0, exports.selectVirtualMarketsInfo)(state)[vMarketId];
};
exports.selectVirtualMarketInfo = selectVirtualMarketInfo;
const getOutcomeTypeById = (state, outcomeTypeId) => (0, exports.getCommonDataEntries)(state).outcomeTypes[outcomeTypeId];
exports.getOutcomeTypeById = getOutcomeTypeById;
const selectMarkets = (state) => (0, exports.getCommonDataEntries)(state).markets;
exports.selectMarkets = selectMarkets;
const selectVMarketIdsByMarket = (state) => (0, exports.getCommonDataEntries)(state).vMarketIdsByMarket;
exports.selectVMarketIdsByMarket = selectVMarketIdsByMarket;
exports.selectVMarketsByMarketId = (0, toolkit_1.createSelector)([
    exports.selectVMarketIdsByMarket,
    exports.selectVirtualMarketsInfo,
    (state, marketId) => marketId,
], (vMarketIdsByMarket, vMarketsInfo, marketId) => {
    return vMarketIdsByMarket[marketId].map((vMarketId) => vMarketsInfo[vMarketId]);
});
const getMarketById = (state, marketId) => (0, exports.selectMarkets)(state)[marketId];
exports.getMarketById = getMarketById;
const getCurrencies = (state) => (0, exports.getCommonDataEntries)(state).currencies;
exports.getCurrencies = getCurrencies;
const getCurrencyById = (state, currencyId) => (0, exports.getCurrencies)(state)[currencyId];
exports.getCurrencyById = getCurrencyById;
const getSystemCurrencyById = (state, currencyId) => { var _a; return (_a = (0, exports.getSystemCurrencies)(state)[currencyId]) === null || _a === void 0 ? void 0 : _a.currency; };
exports.getSystemCurrencyById = getSystemCurrencyById;
const getSystemCurrencies = (state) => (0, exports.getCommonDataEntries)(state).systemCurrencies;
exports.getSystemCurrencies = getSystemCurrencies;
const selectSport = (state, sportId) => (0, exports.selectSports)(state)[sportId];
exports.selectSport = selectSport;
const selectChildrenSportIds = (state, sportId) => {
    var _a;
    return (_a = (0, exports.selectChildrenSportMap)(state)[sportId]) !== null && _a !== void 0 ? _a : array_1.EMPTY_ARRAY;
};
exports.selectChildrenSportIds = selectChildrenSportIds;
const selectChildrenSportMap = (state) => {
    return (0, exports.getCommonDataEntries)(state).sportIdsByGenericSportId;
};
exports.selectChildrenSportMap = selectChildrenSportMap;
const selectIsGenericSport = (state, sportId) => {
    const childSportIds = (0, exports.selectChildrenSportIds)(state, sportId);
    return childSportIds.length > 0;
};
exports.selectIsGenericSport = selectIsGenericSport;
const selectMatchPhases = (state) => (0, exports.getCommonDataEntries)(state).matchPhases;
exports.selectMatchPhases = selectMatchPhases;
const selectMatchPhase = (state, phaseId) => (0, exports.selectMatchPhases)(state)[phaseId];
exports.selectMatchPhase = selectMatchPhase;
const selectCommonDataFetchItems = (state) => state.commonDataProvider.fetchItems || slice_1.initialState.fetchItems;
exports.selectCommonDataFetchItems = selectCommonDataFetchItems;
const selectMainOutcomeTypes = (state) => (0, exports.getCommonDataEntries)(state).mainOutcomeTypes;
exports.selectMainOutcomeTypes = selectMainOutcomeTypes;
const selectOutcomeTypes = (state) => (0, exports.getCommonDataEntries)(state).outcomeTypes;
exports.selectOutcomeTypes = selectOutcomeTypes;
const selectEntityTags = (state) => (0, exports.getCommonDataEntries)(state).entityTags;
exports.selectEntityTags = selectEntityTags;
exports.selectTopTagId = (0, toolkit_1.createSelector)([exports.selectEntityTags], (entityTags) => (0, index_1.getTopTagId)(entityTags));
const selectOutcomeTypeById = (state, id) => (0, exports.selectOutcomeTypes)(state)[id];
exports.selectOutcomeTypeById = selectOutcomeTypeById;
exports.selectMarketCategories = (0, toolkit_1.createSelector)(exports.selectMarketCategoriesMap, ({ entries, sortedIds }) => (0, slices_1.getValues)(sortedIds, entries));
const selectMarketCategoryById = (state, marketCategoryId) => (0, exports.selectMarketCategoriesMap)(state).entries[marketCategoryId];
exports.selectMarketCategoryById = selectMarketCategoryById;
exports.selectMarketGroups = (0, toolkit_1.createSelector)(exports.selectMarketGroupsMap, ({ entries, sortedIds }) => (0, slices_1.getValues)(sortedIds, entries));
const selectMarketGroupById = (state, marketGroupId) => (0, exports.selectMarketGroupsMap)(state).entries[marketGroupId];
exports.selectMarketGroupById = selectMarketGroupById;
const selectSports = (state) => (0, exports.getCommonDataEntries)(state).sports;
exports.selectSports = selectSports;
exports.selectSportsList = (0, toolkit_1.createSelector)([exports.getSportsIdsOrder, exports.selectSports], (sportsIds, sports) => (0, slices_1.getValues)(sportsIds, sports));
const selectAccountCurrencyData = (state) => {
    const id = (0, selectors_1.selectAccountCurrencyId)(state);
    return (0, exports.getSystemCurrencyById)(state, id);
};
exports.selectAccountCurrencyData = selectAccountCurrencyData;
exports.selectCurrencyMinBet = (0, toolkit_1.createSelector)([exports.getSystemCurrencies, selectors_1.selectAccountCurrencyId], (systemCurrencies, currencyId) => {
    var _a, _b;
    const minBet = (_b = (currencyId && ((_a = systemCurrencies[currencyId]) === null || _a === void 0 ? void 0 : _a.min_bet))) !== null && _b !== void 0 ? _b : 0;
    return (0, format_1.adjustAmountForFrontend)(minBet);
});
exports.selectCurrencyMaxPayout = (0, toolkit_1.createSelector)([exports.getSystemCurrencies, selectors_1.selectAccountCurrencyId], (systemCurrencies, currencyId) => {
    var _a, _b;
    const maxPayout = (_b = (currencyId && ((_a = systemCurrencies[currencyId]) === null || _a === void 0 ? void 0 : _a.max_payout))) !== null && _b !== void 0 ? _b : 0;
    return (0, format_1.adjustAmountForFrontend)(maxPayout);
});
const getOutcomeCategories = (state) => (0, exports.getCommonDataEntries)(state).outcomeCategories;
exports.getOutcomeCategories = getOutcomeCategories;
const selectOutcomeCategoryById = (state, id) => (id ? (0, exports.getOutcomeCategories)(state)[id] : undefined);
exports.selectOutcomeCategoryById = selectOutcomeCategoryById;
const selectHotProbabilitiesGroups = (state) => (0, exports.getCommonDataEntries)(state).hotProbabilitiesGroups;
exports.selectHotProbabilitiesGroups = selectHotProbabilitiesGroups;
exports.selectHotProbabilitiesGroupsSports = (0, toolkit_1.createSelector)([exports.selectHotProbabilitiesGroups], (groups) => Object.values(groups)
    .map((item) => Object.values(item.sports).map((sport) => ({
    ...sport,
    groupId: item.id,
})))
    .flat());
exports.selectHotProbsMarkets = (0, toolkit_1.createSelector)([exports.selectMarkets, exports.selectOutcomeTypes], (markets, outcomeTypes) => {
    const hotMarketOrderedIds = (0, findHotProbsMarketsOutcomesIds_1.findHotProbsMarketsOutcomesIds)(outcomeTypes);
    return (0, findHotProbsMarkets_1.findHotProbsMarkets)(Object.values(markets), hotMarketOrderedIds);
});
/*
 Handicaps and Totals are filtered on client side to be shown in the events list as "main probs".
 The selector below returns the value of type ClientFilteredProbsMapWithOutcomeIds
 */
exports.selectClientFilteredProbsMap = (0, toolkit_1.createSelector)([exports.selectOutcomeTypes], (outcomeTypes) => {
    const codeToIdMap = (0, keyBy_1.default)(outcomeTypes, 'code');
    return (0, mapValues_1.default)(constants_1.CLIENT_FILTERED_PROBS_MAP, (outcomeCodes) => outcomeCodes.map((outcomeCode) => { var _a; return (_a = codeToIdMap[outcomeCode]) === null || _a === void 0 ? void 0 : _a.id; }));
});
const selectLoadedOrNotCommonData = (entries) => {
    const sports = Object.keys(entries.sports).length !== 0;
    const markets = Object.keys(entries.markets).length !== 0;
    const currencies = Object.keys(entries.currencies).length !== 0;
    const entityTags = Object.keys(entries.entityTags).length !== 0;
    const systemCurrencies = Object.keys(entries.systemCurrencies).length !== 0;
    const matchPhases = Object.keys(entries.matchPhases).length !== 0;
    const outcomeCategories = Object.keys(entries.outcomeCategories).length !== 0;
    const hotProbabilitiesGroups = Object.keys(entries.hotProbabilitiesGroups).length !== 0;
    const marketCategories = entries.marketCategories.sortedIds.length !== 0;
    const marketGroups = entries.marketGroups.sortedIds.length !== 0;
    const virtualCategories = entries.virtualCategories.sortedIds.length !== 0 ||
        entries.vCategoriesInfo.sortedIds.length !== 0;
    return {
        sports,
        markets,
        currencies,
        entityTags,
        systemCurrencies,
        matchPhases,
        outcomeCategories,
        hotProbabilitiesGroups,
        marketCategories,
        marketGroups,
        virtualCategories,
    };
};
exports.selectLoadedOrNotCommonData = selectLoadedOrNotCommonData;
exports.selectIsAllCommonDataLoaded = (0, toolkit_1.createSelector)([exports.getCommonDataEntries, selectors_2.selectFeatureFlags], (entries, featureFlags) => {
    const { sports, markets, currencies, entityTags, systemCurrencies, matchPhases, outcomeCategories, hotProbabilitiesGroups, marketCategories, marketGroups, virtualCategories, } = (0, exports.selectLoadedOrNotCommonData)(entries);
    const isAllDataLoaded = sports &&
        outcomeCategories &&
        markets &&
        currencies &&
        systemCurrencies &&
        matchPhases &&
        entityTags &&
        hotProbabilitiesGroups &&
        marketCategories &&
        marketGroups &&
        (featureFlags.NEW_OUTCOMES_ENABLED ? virtualCategories : true);
    return isAllDataLoaded;
});
//# sourceMappingURL=selectors.js.map